import { IProductWarning, IProductWarningProps, ProductWarningType } from '../ProductWarning';
import { IDealItem } from '~/types/combo';
import { TBooleanInNumber } from '~/types/main';
import { IProductV4 } from '~/types/product';

type TDealItemsInListData = Pick<IProductWarningProps, 'type' | 'combo'>;
type TDealItemsInEditPageData = Pick<IProductWarningProps, 'comboItem' | 'comboItemOrderTypeWarning'>;

export const dealItemsInListWarning = (data: TDealItemsInListData): IProductWarning | null => {
  const { type, combo } = data;

  const isBranchLevel: boolean = type === ProductWarningType.DEAL_ITEM_BRANCH;

  const statusMessage: string = isBranchLevel ? 'item_bavail_off_oos' : 'item_gavail_off_oos';
  const outOfStockMessage: string = isBranchLevel ? 'item_bins_off_oos' : 'item_gins_off_oos';

  switch (true) {
    case combo?.items?.some((item) => !item.category_status):
      return { message: 'item_cat_off_oos', maxWidth: 340 };
    case combo?.items?.some((item) => !item.status):
      return { message: statusMessage, maxWidth: 290 };
    case combo?.items?.some((item) => item.out_of_stock):
      return { message: outOfStockMessage, maxWidth: 290 };
    case !combo?.order_type:
      return { message: 'dci_order_type_conflict_oos', maxWidth: 308 };
    case combo?.items?.some((item) => item.is_required_modifiers):
      return { message: 'dci_has_mm_oos', maxWidth: 308 };
    case combo?.items?.some((item) => item.is_size):
      return { message: 'dci_has_sizes_oos', maxWidth: 246 };
    case combo?.items?.some((item) => item.is_exclusions):
      return { message: 'dci_has_excl_oos', maxWidth: 308 };
    case combo?.items?.some((item) => item.is_donation):
      return { message: 'dci_is_donatable_oos', maxWidth: 246 };
    default:
      return null;
  }
};

export const dealItemsInEditPageWarning = (data: TDealItemsInEditPageData): IProductWarning | null => {
  const { comboItem, comboItemOrderTypeWarning } = data;

  let categoryStatus: TBooleanInNumber | undefined = undefined;
  if (comboItem && (comboItem as IProductV4)?.category) {
    categoryStatus = (comboItem as IProductV4)?.category?.status;
  } else {
    categoryStatus = (comboItem as IDealItem)?.category_status;
  }

  switch (true) {
    case !categoryStatus:
      return { message: 'item_cat_not_available' };
    case !comboItem?.status:
      return { message: 'item_not_available' };
    case Boolean(comboItem?.out_of_stock):
      return { message: 'item_oos' };
    case Boolean(comboItemOrderTypeWarning):
      return { message: 'dci_order_type_conflict', maxWidth: 246 };
    case Boolean(comboItem?.is_required_modifiers):
      return { message: 'modifier_dc_conflict', maxWidth: 308 };
    case Boolean(comboItem?.is_size):
      return { message: 'sizes_dc_conflict', maxWidth: 246 };
    case Boolean(comboItem?.is_exclusions):
      return { message: 'exclusion_dc_conflict', maxWidth: 308 };
    case Boolean(comboItem?.is_donation):
      return { message: 'donatable_dc_conflict', maxWidth: 246 };
    default:
      return null;
  }
};
